import React, { useState, useEffect } from 'react';
import { Row, Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { history } from '../../../../../redux';
import UserRoleEnum from '../../../../../constants/UserRoleEnum';
import { hasAccessRole } from '../../../../../services/utils';

const PaymentActions = ({
  campaign,
  user,
  isSuperUser,
  loadingProposal,
  creatingToken,
  onProposal,
  onPay
}) => {
  const { t } = useTranslation();

  const [localPay, setLocalPay] = useState(false);
  const [localProposal, setLocalProposal] = useState(false);

  useEffect(() => {
    if (!creatingToken) setLocalPay(false);
  }, [creatingToken]);

  useEffect(() => {
    if (!loadingProposal) setLocalProposal(false);
  }, [loadingProposal]);

  const isPayLoading = localPay || creatingToken;
  const isProposalLoading = localProposal || loadingProposal;
  const isAnyLoading = isPayLoading || isProposalLoading;

  const handlePay = () => {
    if (isAnyLoading) return;
    setLocalPay(true);

    const started = onPay();
    if (started === false) setLocalPay(false);
  };

  const handleProposal = () => {
    if (isAnyLoading) return;
    setLocalProposal(true);
    onProposal();
  };

  const isAgencyOrCompany =
    user && hasAccessRole(user.roles, [UserRoleEnum.agencyMember, UserRoleEnum.companyMember]);

  const isExternalDsp = campaign.external_dsp_id != null && !!campaign.smart_campaign;

  if (isAgencyOrCompany) {
    return (
      <Row type="flex">
        <Tooltip
          placement="bottom"
          title={
            campaign.status === 'proposal'
              ? t(
                  'This option allows you to edit the proposal without generating a payment or changing its status.'
                )
              : t('Generate proposal')
          }
        >
          <Button
            className="finishedButtons proposalButton"
            style={{
              marginRight: '10px',
              zIndex: 1000,
              fontSize: campaign.status === 'proposal' ? '16px' : '18px'
            }}
            loading={isProposalLoading}
            disabled={isAnyLoading}
            onClick={handleProposal}
          >
            {campaign.status === 'proposal' ? t('Proposal updated') : t('Proposal')}
          </Button>
        </Tooltip>

        {!isExternalDsp || isSuperUser ? (
          <Tooltip
            placement="bottom"
            title={t(
              'By selecting this option, a payment will be generated and the proposal will be converted into a campaign.'
            )}
          >
            <span>
              <Button
                loading={isPayLoading}
                disabled={isAnyLoading}
                className="finishedButtons"
                type="primary"
                onClick={handlePay}
              >
                {t('Create campaign')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            loading={isPayLoading}
            disabled={isAnyLoading}
            className="finishedButtons"
            type="primary"
            onClick={() => history.push('/campaign/' + campaign.id)}
          >
            {t('Go to my campaign')}
          </Button>
        )}
      </Row>
    );
  }

  return (
    <Row type="flex">
      <Button
        loading={isPayLoading}
        disabled={isAnyLoading}
        className="finishedButtons"
        type="primary"
        onClick={handlePay}
      >
        {t('Finish')}
      </Button>
    </Row>
  );
};

export default PaymentActions;
